import safeFetch from '../extenstions/safeFetch';
import url from '../extenstions/url';
import parseResponseTime from '../extenstions/parseResponseTime';

export default (id, secret, setTask) => safeFetch(
    `${url.tasks.get}/${id}?secret=${secret}`,
)
    .then(parseResponseTime)
    .then(setTask);
